import SearchSimple from '../../../components/SearchSimples/SearchSimple';
import { PurchaseOrderTabApp } from './Functionality/PurchaseOrderTabApp';
import CustomTable from '../../../components/table/CustomTable';
import DeleteModal from '../../Modals/DeleteModal';
import { permissionObj } from '../../../Helpers/permission';
import CustomButtonLink from '../../../components/buttons/CustomButtonLink';
import DeliveryModal from './Modal/DeliveryModal';
import ConfirmModal from '../../Dashboard/Visitor/Invitation/Modal/ConfirmModal';

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

const PurchaseOrderTab = ({
    supplierId,
    searchElement,
    setSearch,
    contractorId,
    setSimpleSearch,
    setSearchElement,
    setBodyForExport,
    selectedList,
    setSelectedList,
    deleteOrderShow,
    setDeleteOrderShow,
    setModified,
    modified,
    isAllChecked,
    setIsAllChecked,
    handleCreate,
}) => {
    const {
        t,
        DEV,
        permission,
        tableId,
        searchId,
        thead,
        tbody,
        page,
        rowsPerPage,
        option,
        setData,
        deletePermission,
        handleDeleteAll,
        deleteSelectedOrders,
        getActionsButtons,
        pagination,
        handleCheckboxChange,
        showDeliveryModal,
        setShowDeliveryModal,
        showCancelModal,
        setShowCancelModal,
        cancelOrder
    } = PurchaseOrderTabApp({
        supplierId,
        searchElement,
        contractorId,
        setModified,
        modified,
        setBodyForExport,
        setSelectedList,
        setIsAllChecked,
    });

    return (
        <>
            <div className='mt-2'>
                <SearchSimple
                    id={'txt_prp_search_simple_2'}
                    setBodyForExport={setBodyForExport}
                    setSearchResults={setData}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    optionTable={option}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    contractorId={contractorId}
                    supplierId={supplierId}
                />
            </div>
            <CustomTable tableId={tableId}
                         searchId={searchId}
                         checkbox={deletePermission}
                         checkboxTitle={"de_/_select_all"}
                         isAllChecked={isAllChecked}
                         onChangeCheckbox={handleDeleteAll}
                         thead={thead}
                         tbody={tbody}
                         columnActions={true}
                         getActionsButtons={getActionsButtons}
                         handleCheckboxChange={handleCheckboxChange}
                         selectedList={selectedList}
                         childrenNotInformation={tbody?.data?.length === 0 ? <>
                                 <div className={"warning-text"}>
                                     <p>{t("you_haven_not_created_any_purchase_order_yet")}</p>
                                 </div>
                                 { (DEV || permission?.includes(permissionObj?.WEB_SUPPLIER_ORDER_CREATE)) &&
                                 <CustomButtonLink splitName={false} id={'btn_pot_create'} card={true}
                                                   onClick={handleCreate}
                                                   name={'create_new_purchase_order'}/>
                                 } </>
                             : undefined
                         }
            />
            {pagination()}

            <DeleteModal
                show={deleteOrderShow}
                onHide={() => setDeleteOrderShow(false)}
                onClickFn={() => deleteSelectedOrders(selectedList)}
                data={selectedList}
                title_modal={t('delete_orders')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('orders')}
            />
            {showDeliveryModal && <DeliveryModal show={showDeliveryModal} onHide={() => setShowDeliveryModal(false)} />}
            {showCancelModal && (
                <ConfirmModal
                    show={showCancelModal}
                    onHide={() => setShowCancelModal(false)}
                    onClickFn={() => {
                        cancelOrder(selectedList);
                        setShowCancelModal(false);
                    }}
                    title_modal={'cancel_purchase_order'}
                    isReset={() => setSelectedList([])}
                    description={t('cancel_purchase_order_confirm')}
                />
            )}
        </>
    );
};

export default PurchaseOrderTab;
